import { environmentCommon } from './environment.common';

export const environment = {
	...environmentCommon,
	name: 'Development',
	production: false,
	staging: false,
	dev: true,
	hmr: true,
	webApi: '/api',
	translations: {
		...environmentCommon.translations,
		merged: false,
	},
};
